module.exports = __webpack_public_path__ + "img/8.bc543e65.png";